<template>
  <div class="container-fluid">
    <div class="block-header">
      <div class="clearfix row breadcrumb-margin-lg">
        <div class="col-6 col-md-6 col-sm-6 mt-1">
          <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
              <li class="breadcrumb-item"><a href="#">Master</a></li>
              <li class="breadcrumb-item active" aria-current="page">Category</li>
            </ol>
          </nav>
        </div>
        <div class="col-6 col-md-6 col-sm-6">
          <router-link
            :to="{ name: 'AddCategory', params: { id: this.$route.params.id } }"
            class="float-right btn btn-info"
            title="Add New Category"
            ><i class="pr-1 fa fa-plus"></i>Add Category</router-link
          >
        </div>
      </div>
    </div>

    <div class="clearfix row">
      <div class="col-lg-12">
        <div class="card body-margin">
          <!--  <div class="header">
            <ul class="header-dropdown dropdown">
               <li>
                  <a href="javascript:void(0);" class="full-screen"
                    ><i class="icon-frame"></i
                  ></a>
                </li> 
            </ul>
          </div>-->

          <div class="body">
            <v-app>
              <div>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Search"
                    outlined
                    dense
                    hide-details
                    class="top-fix br-radius"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="12">
                  <v-card class="mx-auto" tile>
                    <!-- <v-card-title>Category</v-card-title> -->
                    <ag-grid-vue
                      class="ag-theme-alpine"
                      style="width: 100%; height: auto"
                      :rowData="categories"
                      :columnDefs="columnDefs"
                      :defaultColDef="defaultColDef"
                      :pagination="false"
                      :domLayout="'autoHeight'"
                      :context="{ componentParent: this }"
                    />

                    <v-col cols="12" sm="12">
                      <v-row>
                        <v-col cols="4" sm="3">
                          <v-select
                            attach=""
                            v-model="pageSize"
                            :items="pageSizes"
                            :menu-props="{ bottom: true, offsetY: true }"
                            label="Items per Page"
                            @change="handlePageSizeChange"
                          ></v-select>
                        </v-col>

                        <v-col cols="12" sm="9">
                          <v-pagination
                            v-model="currentPage"
                            :length="lastPage"
                            @input="handlePageChange"
                            total-visible="10"
                          ></v-pagination>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-card>
                </v-col>
              </div>
            </v-app>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DataService from '../../../dataservice';
import { AgGridVue } from 'ag-grid-vue';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
export default {
  components: {
    AgGridVue,
  },
  data() {
    return {
      categories: [],
      loading: true,
      totalItems: 0,
      currentPage: 1,
      lastPage: 0,
      search: '',
      searchTimeout: null,
      pageSize: 10,
      pageSizes: [10, 25, 50, 100],
      headers: [
        { text: 'Sr. No.', value: 'index' },
        // { text: "Category Id", value: "category_id" },
        { text: 'Actions', value: 'actions', sortable: false },
        { text: 'Category Name', value: 'category_title' },
        // { text: 'Category Icon', value: 'category_icon' },
        // { text: 'Image', value: 'image' },
        { text: 'Description', value: 'category_description' },
        { text: 'Category Featured', value: 'category_featured' },
        { text: 'Active Status', value: 'category_isactive' },
        { text: 'SEO Name', value: 'seoname' },
        { text: 'Global Faq', value: 'get_global_faq.name' },
        { text: 'SAC', value: 'sac' },
        { text: 'Order', value: 'order' },
      ],
      columnDefs: [
        {
          headerName: 'Sr. No.',
          valueGetter: params =>
            this.categories.indexOf(params.data) + 1 + (this.currentPage - 1) * this.pageSize,
          width: 100,
        },

        {
          headerName: 'Actions',
          field: 'actions',
          width: 300,
          cellRenderer: params => {
            const button = document.createElement('button');

            button.innerHTML = `Action <i class="fa fa-chevron-down"></i>`;
            button.classList.add('btn', 'btn-primary');

            button.addEventListener('click', e => {
              e.stopPropagation();

              const oldMenu = document.getElementById('action-menu');
              if (oldMenu) oldMenu.remove();

              const actions = this.actionmenu(params.data);

              const menu = document.createElement('div');
              menu.id = 'action-menu';
              menu.style.position = 'fixed';
              menu.style.background = '#fff';
              menu.style.borderRadius = '8px';
              menu.style.color = '#334155';
              menu.style.boxShadow = '0 4px 12px rgba(0,0,0,0.15)';
              menu.style.padding = '8px 0';
              menu.style.zIndex = '9999';
              menu.style.minWidth = '200px';

              actions.forEach(action => {
                const item = document.createElement('div');

                item.style.display = 'flex';
                item.style.alignItems = 'center';
                item.style.gap = '8px';
                item.style.color = '#334155';
                item.style.padding = '8px 12px';
                item.style.cursor = 'pointer';

                const icon = document.createElement('i');
                icon.className = `mdi ${action.icon}`;

                const text = document.createElement('span');
                text.innerText = action.text;

                item.appendChild(icon);
                item.appendChild(text);

                item.addEventListener('click', () => {
                  this.performAction(action, params.data.category_id);
                  menu.remove();
                });

                item.addEventListener('mouseover', () => {
                  item.style.background = '#f5f5f5';
                });

                item.addEventListener('mouseout', () => {
                  item.style.background = '#fff';
                });

                menu.appendChild(item);
              });

              document.body.appendChild(menu);

              const rect = button.getBoundingClientRect();
              menu.style.top = rect.bottom + 'px';
              menu.style.left = rect.left + 'px';

              // close on outside click
              setTimeout(() => {
                const handler = () => {
                  menu.remove();
                  document.removeEventListener('click', handler);
                };
                document.addEventListener('click', handler);
              });

              // close on scroll
              const scrollHandler = () => {
                const existing = document.getElementById('action-menu');
                if (existing) existing.remove();
                window.removeEventListener('scroll', scrollHandler);
              };
              window.addEventListener('scroll', scrollHandler);
            });

            return button;
          },
        },

        {
          headerName: 'Category Name',
          field: 'category_title',
          width: 200,
        },

        // {
        //   headerName: 'Category Icon',
        //   field: 'category_icon',
        //   cellRenderer: params => params.value,
        //   width: 150,
        // },

        // {
        //   headerName: 'Image',
        //   field: 'image',
        //   cellRenderer: params => `<img src="${params.value}" style="height:70px;width:70px;" />`,
        //   width: 120,
        // },

        {
          headerName: 'Description',
          field: 'category_description',
          width: 300,
          wrapText: true,
          autoHeight: true,
          cellStyle: {
            whiteSpace: 'normal',
            lineHeight: '1.4',
          },
        },

        {
          headerName: 'Category Featured',
          field: 'category_featured',
          width: 150,
        },

        {
          headerName: 'Active Status',
          field: 'category_isactive',
          width: 150,
        },

        {
          headerName: 'SEO Name',
          field: 'seoname',
          width: 200,
        },

        {
          headerName: 'Global Faq',
          valueGetter: params => params.data?.get_global_faq?.name || '',
          width: 180,
        },

        {
          headerName: 'SAC',
          field: 'sac',
          width: 100,
        },

        {
          headerName: 'Order',
          field: 'order',
          width: 100,
        },
      ],
    };
  },
  //this one will populate new data set when user changes current page.
  //  watch: {
  //     currentPage() {
  //       this.readData(this.$route.params.id);
  //     },
  //   },
  watch: {
    search(val) {
      clearTimeout(this.searchTimeout);
      this.searchTimeout = setTimeout(() => {
        this.currentPage = 1;
        this.readData(this.$route.params.id);
      }, 500);
    },
  },
  methods: {
    handlePageChange(value) {
      this.currentPage = value;
      this.readData(this.$route.params.id);
    },
    handlePageSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.readData(this.$route.params.id);
    },
    actionmenu(item) {
      const actionmenu = [
        { text: 'Edit', icon: 'mdi-pencil' },
        { text: 'Meta Tags', icon: 'mdi-plus' },
        { text: 'Faq', icon: 'mdi-plus' },
        { text: 'PageDesign', icon: 'mdi-plus' },
        {
          text: item.category_featured === 'Y' ? 'Unfeature' : 'Make it Feature',
          icon: item.category_featured === 'Y' ? 'mdi-close-circle' : 'mdi-check-circle',
        },
        {
          text: item.category_isactive == 'N' ? 'Activate' : 'Deactivate',
          icon:
            item.category_isactive == 'N' ? 'mdi-toggle-switch' : 'mdi-toggle-switch-off-outline',
        },
        { text: 'Delete', icon: 'mdi-delete' },
      ];

      return actionmenu;
    },
    performAction(action, id) {
      if (action.text == 'Edit') this.editCategory(id);
      else if (action.text == 'Make it Feature' || action.text == 'Unfeature')
        this.FeatureUnfeature(id);
      else if (action.text == 'Activate' || action.text == 'Deactivate')
        this.ToggleCategoryActiveStatus(id);
      else if (action.text == 'Delete') this.deleteCategory(id);
      else if (action.text == 'Faq') this.SectorFaq(id);
      else if (action.text == 'Meta Tags') this.metaTag(id);
      else if (action.text == 'PageDesign') this.pagedesign(id);
    },
    pagedesign(id) {
      this.$router.push({ name: 'CategoryDesign', params: { id: id } });
    },
    metaTag(id) {
      // alert(id);
      this.$router.push({ name: 'CategoryMetaTag', params: { id: id } });
    },
    SectorFaq(id) {
      // alert(id);
      this.$router.push({ name: 'CategoryFaq', params: { id: id } });
    },
    readData(id) {
      this.loading = true;
      DataService.getCategoryfilter(id, this.currentPage, this.pageSize, this.search)
        .then(response => {
          this.categories = response.data.data;
          this.totalItems = response.data.total;
          this.loading = false;
          this.currentPage = response.data.current_page;
          this.lastPage = response.data.last_page;
        })
        .catch(e => {
          // console.log(e);
        });
    },

    ToggleCategoryActiveStatus(id) {
      DataService.CategoryActiveStatusToggle(id).then(response => {
        this.s('Category', 'Status has been updated successfully.');
        this.readData(this.$route.params.id);
        this.refreshList();
      });
    },
    editCategory(id) {
      this.$router.push({ name: 'EditCategory', params: { id: id } });
    },
    deleteCategory(id) {
      DataService.deleteCategory(id).then(response => {
        this.s('Record Deleted');
        this.readData(this.$route.params.id);
        this.refreshList();
      });
    },
    FeatureUnfeature(categoryId) {
      DataService.CategoryFeatureUnfeature(categoryId).then(response => {
        this.s('Category', 'Feature staus updated.');
        this.refreshList();
      });
    },
    refreshList() {
      this.readData(this.$route.params.id);
    },
  },
  created() {
    this.readData(this.$route.params.id);
  },
};
</script>
<style scoped>
.top-fix {
  margin-top: -48px !important;
  margin-bottom: -16px !important;
}
.body-margin {
  margin-top: -24px !important;
}
</style>

<style>
.menu-item {
  padding: 8px 10px;
  cursor: pointer;
}

.menu-item:hover {
  background: #f5f5f5;
}
</style>
